<template>
  <div class="panel-in-tab">
    <search-box class="search-box">
      <el-form :inline="true" size="mini" label-width="110px" :model="searchForm" :rules="rules" ref="searchForm">
        <el-form-item label="上市清单名称" prop="name">
          <el-input v-model.trim="searchForm.name" placeholder="请输入" @keyup.enter.native="onSearch" />
        </el-form-item>
        <el-form-item label="发布时间">
          <form-date-range
            :form="searchForm"
            startKey="dts"
            endKey="dte"
            :usingTime="false"
            valueFormat="yyyy-MM-dd"
          ></form-date-range>
        </el-form-item>
      </el-form>
      <template v-slot:right>
        <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
        <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
      </template>
    </search-box>
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </template>
      <el-table
        stripe
        border
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        :data="tableData.list"
        :height="maxTableHeight"
        v-if="tableReload"
        v-loading="loading"
      >
        <el-table-column v-for="(item, index) in columnList" :key="index" :prop="item.prop" :label="item.label" :min-width="item.width">
          <template #header>
            <span class="header-with-tips">
              {{ item.label }}
              <el-tooltip class="item" effect="dark" :content="item.tips" placement="top" v-if="item.tips">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </span>
          </template>
          <template slot-scope="{ row }">
            <template v-if="item.prop == 'name'">
              <el-button type="text" @click="goListingList(row)">{{ row.name }}</el-button>
            </template>
            <template v-else>
              <span>{{ row[item.prop] }}</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="220">
          <template slot-scope="{ row }">
            <el-button type="text" @click="viewProductDetails(row)">查看商品详情</el-button>
            <el-button type="text" @click="viewStoreDetails(row)">查看店铺详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[10, 30, 60, 90]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
  </div>
</template>

<script>
import tableMixin from '@/utils/tableMixin';
import pagePathMixin from '@/utils/page-path-mixin';
export default {
  name: 'InventoryData',
  mixins: [tableMixin, pagePathMixin],
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      tableReload: true,
      searchFormData: [],
      rules: {},
      searchForm: {
        name: '',
        dts: '',
        dte: '',
      },
      columnList: [
        { prop: 'name', label: '上市清单名称', width: '150' },
        { prop: 'publishDate', label: '发布时间', width: '120' },
        { prop: 'needSKuQty', label: '需上架商品数', width: '120' },
        {
          prop: 'upSkuQty',
          label: '已上架商品数',
          width: '150',
          tips: '负责此商品的所有店铺都已全部上架的商品',
        },
        {
          prop: 'noUpSkuQty',
          label: '未上架商品数',
          width: '150',
          tips: '存在还未进行上架操作店铺的商品',
        },
        {
          prop: 'needStoreQty',
          label: '需上架店铺数',
          width: '150',
        },
        {
          prop: 'upStoreQty',
          label: '已上架店铺数',
          width: '150',
          tips: '所负责的商品全部都已经上架的店铺',
        },
        {
          prop: 'noUpStoreQty',
          label: '未上架店铺数',
          width: '150',
          tips: '所负责的商品还存在待上架的店铺',
        },
      ],
    };
  },
  methods: {
    onSearch() {
      this.tableData.pageNum = 1;
      this.init();
    },

    async init() {
      this.loading = true;
      let data = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: {
          ...this.searchForm,
        },
      };
      this.searchFormData = data;

      this.$q.newProduct
        .listStatisPage({ data: data })
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },

    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },

    reset() {
      this.searchForm = {
        name: '',
        dts: '',
        dte: '',
      };
      this.onSearch();
    },

    // 导出
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: '导出中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      let params = {
        appCode: 'ec-pc-new',
        paramMap: {
          ...this.searchFormData.filterData,
        },
        reportName: 'productListStatiscExport',
      };
      this.$q.common.exportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success('提交下载任务成功，请稍后到导出列表查阅！');
          loading.close();
        } else {
          this.$message.error(res.message);
        }
      });
    },

    goListingList(row) {
      this.$router.push({ path: '/newProduct/listingList', query: {name: row.name} });
    },

    // 查看商品详情
    viewProductDetails(row) {
      let data = {
        listNo: row.listNo,
        tabName: 'GoodsData'
      }
      this.$emit('switchTab',data)
    },

    // 查看店铺详情
    viewStoreDetails(row) {
      let data = {
        listNo: row.listNo,
        tabName: 'StoreData'
      }
      this.$emit('switchTab',data)
    },
  },
  mounted() {
    this.onSearch();
  },
};
</script>

<style lang="stylus" scoped>
.panel-in-tab {
  >>> .search-outer>div {
    padding: 0;
  }
}

.search-box
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input
      width 240px !important
  >>> .date-range .single-date
    width 110px !important

>>> .form-number-input .el-input-number {
  width: 105px !important;
}

>>> .form-number-input .el-input-number .el-input {
  width: 105px !important;
}

.header-with-tips {
  display: flex;
  align-items: center;

  .el-icon-question {
    margin-left: 5px;
    color: #909399;
    cursor: pointer;
  }
}
</style>
